// NPM Imports
import { createSelector } from "reselect";
import { getComponentList } from "../../../../utils/quotationUtils";

const _getSignatureSection = signatories =>
  signatories.map(item => item.signers).flat(1);

export const isSignersListValid = createSelector(
  [_getSignatureSection],
  signerDetails =>
    signerDetails.length > 0
      ? signerDetails.every(
          data =>
            data.signer_email !== "" &&
            data.first_name !== "" &&
            data.last_name !== "",
        )
      : false,
);

export const signersListCount = createSelector(
  [_getSignatureSection],
  signerDetails => signerDetails.length,
);

export const signersListDetails = createSelector(
  [_getSignatureSection],
  signerDetails =>
    signerDetails.map(signer => ({
      user_email: signer.signer_email,
      first_name: signer.first_name,
      last_name: signer.last_name,
      image_url: signer.signer_config.image_url,
      recipientId: signer.id,
    })),
);

export const getOrderedSignersList = (signatories, layout) => {
  if (Array.isArray(layout) && layout.length !== 0) {
    const componentList = getComponentList(layout);
    const signersList = [];
    componentList.forEach(componentId => {
      const signatureBlock = signatories.find(
        sig => sig.component_id === componentId,
      );
      if (signatureBlock) {
        const { signers } = signatureBlock;
        if (Array.isArray(signers) && signers.length > 0) {
          signers.forEach(signer => {
            if (
              signer.signer_email !== undefined &&
              signersList.find(s => s.signer_email === signer.signer_email)
            ) {
              const index = signersList.findIndex(
                s => s.signer_email === signer.signer_email,
              );
              signersList[index].occurences = [
                ...signersList[index].occurences,
                componentId,
              ];
            } else {
              signersList.push({
                ...signer,
                occurences: [componentId],
              });
            }
          });
        }
      }
    });
    return signersList;
  }
  if (!Array.isArray(layout) || layout.length === 0) {
    const signersDict = {};
    signatories.forEach(signatureBlock => {
      const { component_id: componentId, signers } = signatureBlock;
      if (Array.isArray(signers) && signers.length > 0) {
        signers.forEach(signer => {
          if (
            signer.signer_email !== undefined &&
            signersDict[signer.signer_email]
          ) {
            signersDict[signer.signer_email] = {
              ...signersDict[signer.signer_email],
              occurences: [
                ...signersDict[signer.signer_email].occurences,
                componentId,
              ],
            };
          } else {
            signersDict[signer.signer_email] = {
              ...signer,
              occurences: [componentId],
            };
          }
        });
      }
    });
    const signersList = Object.values(signersDict);
    return signersList;
  }

  return signatories;
};

export const fetchSignersList = (signatories, layout) => {
  const signersList = getOrderedSignersList(signatories, layout);
  return signersList;
};



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV3/Buttons/eSignBtn/eSignBtnSelector.js